import { useState } from "react";
import DataDlIcon from "../../icons/DataDlIcon";
import Modal, { ModalRoot, ModalTrigger } from "../Modal";
import { Dialog } from "radix-ui";
import DownloadIcon from "../../icons/DownloadIcon";
import { StickyFooter } from "../../stickyFooter/modalStickyFooter";
import Button from "@/components/bricks/button/Button";
import { defaultApiUrl, openReportWithAuth } from "@/api/util";
import { KodeSelect } from "../../formcontrols/KodeSelect";

export default function KursusKategoriDownloadModal(props: {
  close: () => void;
}) {
  const [selected, setSelected] = useState<KodeListe | null>(null);

  const downloadHandler = async () => {
    if (selected?.nr == null) return;
    try {
      await openReportWithAuth(
        `${defaultApiUrl}reports/kursuskategori?nr=${selected.nr}`,
      );
      props.close();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Modal
      title={
        <>
          <DataDlIcon />
          Kursuskategori
        </>
      }
    >
      <div className="c-modal-container">
        <div className="c-modal-container-inner c-item-list">
          <KodeSelect
            kodeListeType="FmukursusKategori"
            placeholder="Vælg kursuskategori"
            onChange={(item) => setSelected(item)}
          />
        </div>
      </div>
      <StickyFooter>
        <Dialog.Close className="btn btn-secondary">Annuller</Dialog.Close>
        <Button
          color="primary"
          disabled={!selected}
          type="submit"
          onClick={() => void downloadHandler()}
        >
          <DownloadIcon /> Hent
        </Button>
      </StickyFooter>
    </Modal>
  );
}

export const KursusKategoriDownloadModalWithRoot = ({
  disabled,
  modalTrigger,
}: {
  modalTrigger?: React.ReactElement;
  disabled?: boolean;
}) => {
  const [open, setOpen] = useState(false);
  return (
    <ModalRoot
      controller={{
        open,
        setOpen,
      }}
    >
      <ModalTrigger asChild>
        {modalTrigger ? (
          modalTrigger
        ) : (
          <Button
            disabled={disabled}
            color="primary"
            icon
            transparent
            className="tooltip-center"
            aria-label="Hent udtræk..."
          >
            <span className="icon-bg">
              <DownloadIcon />
            </span>
          </Button>
        )}
      </ModalTrigger>
      <KursusKategoriDownloadModal close={() => setOpen(false)} />
    </ModalRoot>
  );
};
